import { useEffect, useState } from 'react';

// Custom hook to load initial data on app startup
const useDataLoader = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [currentSeason, setCurrentSeason] = useState(null);

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        // Dynamic import to avoid hook errors
        const { default: useStore } = await import('../store/store');
        const store = useStore.getState();
        // Fetch all initial data from API
        await store.fetchInitialData();

        // Get updated store state after data load
        const updatedStore = useStore.getState();

        // Set current season
        if (updatedStore.seasons && updatedStore.seasons.length > 0) {
          const getPriorityDate = (season) => {
            return season.registration_start_date || season.start_date || season.end_date || null;
          };

          const sortedSeasons = [...updatedStore.seasons].sort((a, b) => {
            const aDate = new Date(getPriorityDate(a) || 0);
            const bDate = new Date(getPriorityDate(b) || 0);
            return bDate - aDate;
          });
          setCurrentSeason(sortedSeasons[0]);
          store.setCurrentSeason(sortedSeasons[0]);
        }
      } catch (error) {
        console.error('❌ Error loading initial data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadInitialData();
  }, []);

  return {
    isLoading,
    currentSeason,
  };
};

export default useDataLoader;
